<template>
    <div>
        <div class="d-lg-none">
            <b-button
                v-b-toggle.nav-sidebar
                variant="dark"
                class="mb-4"
                size="lg"
            >
                <b-icon-arrow-bar-right/> Licenciaturas
            </b-button>

            <b-sidebar
                id="nav-sidebar"
                title="Licenciaturas"
                backdrop-variant="dark"
                backdrop
                shadow
                lazy
                v-model="sidebarVisible"
            >
                <b-tabs
                    pills
                    vertical
                    nav-wrapper-class="w-100"
                >
                    <b-tab
                        v-for="career in careerList"
                        :key="career"
                        :title="career"
                        :active="career == homePageActiveCareer"
                        @click="mobileSelectCareer(career)"
                    />
                </b-tabs>
            </b-sidebar>
        </div>
        <b-jumbotron class="py-5 d-none d-lg-block">
            <h3 class="text-center mb-3">Licenciaturas</h3>
            <div>
                <b-tabs
                    pills
                    vertical
                    nav-wrapper-class="w-100"
                >
                    <b-tab
                        v-for="career in careerList"
                        :key="career"
                        :title="career"
                        :title-item-class="bTabItemClasses"
                        :title-link-class="bTabLinkClasses"
                        :active="career == homePageActiveCareer"
                        @click="setHomeActiveCareer(career)"
                    />
                </b-tabs>
            </div>
        </b-jumbotron>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    name: 'HomeCareerSelector',
    data () {
        return {
            sidebarVisible: false,
            bTabItemClasses: ['my-1', 'border', 'border-primary', 'rounded-lg'],
            bTabLinkClasses: ['px-2', 'py-3', 'text-center']
        }
    },
    computed: {
        ...mapState([
            'careerList',
            'homePageActiveCareer'
        ])
    },
    methods: {
        ...mapActions([
            'setHomeActiveCareer'
        ]),
        mobileSelectCareer (career) {
            this.setHomeActiveCareer(career)
            this.sidebarVisible = false
        }
    }
}
</script>
